import { Component, inject } from '@angular/core'
import { Router } from '@angular/router'

@Component({ selector: 'app-not-found', templateUrl: './not-found.component.html', styleUrls: ['./not-found.component.scss'], host: { class: 'motion-slide-enter' } })
export class NotFoundComponent {
  private router: Router = inject(Router)

  notFoundImage: string = 'assets/images/octavio/not-found-version.webp'
  brandingImage: string = 'assets/images/branding/octa-white-full.png'

  public navigateToLogin(): void {
    this.router.navigate(['/home'])
  }
}
